import _objectWithoutProperties from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "onAction", "getOffsetWidth"];
import React, { useRef, useEffect } from 'react';
import styles from './SecondaryAction.scss.js';
import { Button } from '../../../Button/Button.js';

function SecondaryAction(_ref) {
  var children = _ref.children,
      onAction = _ref.onAction,
      getOffsetWidth = _ref.getOffsetWidth,
      rest = _objectWithoutProperties(_ref, _excluded);

  var secondaryActionsRef = useRef(null);
  useEffect(function () {
    var _secondaryActionsRef$;

    if (!getOffsetWidth || !secondaryActionsRef.current) return;
    getOffsetWidth((_secondaryActionsRef$ = secondaryActionsRef.current) === null || _secondaryActionsRef$ === void 0 ? void 0 : _secondaryActionsRef$.offsetWidth);
  }, [getOffsetWidth]);
  return /*#__PURE__*/React.createElement("span", {
    className: styles.SecondaryAction,
    ref: secondaryActionsRef
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onAction
  }, rest), children));
}

export { SecondaryAction };